import { BankAccount, StripePaymentMethod, WirePaymentMethod } from 'types/payment';

export const plaidEntry: BankAccount = {
	id: '-1',
	label: 'New bank account',
	primaryAccount: false,
	accountType: 'CHECKING',
	accountTypeLabel: '',
	accountNumber: '',
	routingNumber: '',
	bankName: '',
	paymentMethodType: 'ACH'
};

export const stripeEntry: StripePaymentMethod = {
	paymentType: 'DEBIT_CARD',
	stripePaymentMethodId: '',
	id: '-2',
	label: 'New debit card',
	labelWithoutPaymentType: '',
	paymentMethodType: 'STRIPE'
};

export const stripeGenericEntry: StripePaymentMethod = {
	paymentType: 'DEBIT_CARD',
	stripePaymentMethodId: '',
	id: '-2',
	label: 'New card',
	labelWithoutPaymentType: '',
	paymentMethodType: 'STRIPE'
};

export const wireEntry: WirePaymentMethod = {
	id: '-3',
	wirePaymentMethodId: '',
	label: 'Wire transfer',
	primaryAccount: true,
	paymentMethodType: 'WIRE'
};
